import { HttpContextToken } from '@angular/common/http';

export const TIMEOUT = new HttpContextToken<number>(() => 30000);
